/* Almla redesign: cart drawer.
   Markup and styling come from the Cortex Page Builder cart drawer design. The
   design's script kept the bag in memory; this one runs on the Shopify Ajax
   Cart API so the drawer, header count and checkout all read the real cart.

   Product cards register themselves for the "You may also like" upsells:
     AlmCart.register([{h, v, t, p, i, g, k, s, b}])
       h handle, v variant id, t title, p price in cents, i image url,
       g group (for variant dots), k kind label, s sold out, b best seller
   and add with AlmCart.add(handle or variantId, qty).

   Thresholds come from data attributes set by sections/alm-header.liquid:
   data-ship (free shipping, in cents) and data-gift (optional second tier,
   0 hides it). */
window.AlmCart = (function () {
  var root = document.getElementById("almCd");
  if (!root) return null;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  // Thresholds are set in the shop's base currency; the cart reports totals in
  // the shopper's presentment currency, so convert with Shopify's live rate.
  var RATE = +(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
  // Converted thresholds round up to a whole unit, so "$9,673" not "$9,672.44".
  var conv = function (c) { return RATE === 1 ? c : Math.ceil(c * RATE / 100) * 100; };
  var SHIP = conv(+root.getAttribute("data-ship") || 0);
  var GIFT = conv(+root.getAttribute("data-gift") || 0);
  var GIFT_NAME = root.getAttribute("data-gift-name") || "mystery pair";
  var CAT = {}, ORDER = [], cart = { items: [], total_price: 0, item_count: 0 };
  var $ = function (s) { return root.querySelector(s); };
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  };
  function money(cents) {
    var v = (cents || 0) / 100;
    return "$" + v.toLocaleString("en-US", { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  function register(list) {
    (list || []).forEach(function (x) {
      if (!x || !x.h) return;
      if (!CAT[x.h]) ORDER.push(x.h);
      CAT[x.h] = Object.assign(CAT[x.h] || {}, x);
    });
  }
  function inCart(h) { return cart.items.some(function (l) { return l.handle === h; }); }

  function api(path, body) {
    return fetch(ROOT + path, {
      method: body ? "POST" : "GET",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function refresh() {
    return api("cart.js").then(function (c) { cart = c; render(); return c; });
  }
  function pop() {
    document.querySelectorAll(".alm-cart").forEach(function (c) {
      c.classList.remove("acd-pop"); void c.offsetWidth; c.classList.add("acd-pop");
    });
  }
  function error(msg) {
    var box = $("[data-acd-items]");
    var p = document.createElement("p");
    p.className = "acd-empty acd-err";
    p.setAttribute("role", "alert");
    p.textContent = msg || "That item could not be added. Please try again.";
    box.insertBefore(p, box.firstChild);
    open();
  }

  /* key is a registered handle or a numeric variant id. props: optional
     line item properties (Rebuy attribution, see alm-rebuy.js). */
  function add(key, n, silent, props) {
    var p = CAT[key];
    var id = p ? p.v : key;
    if (!id) return Promise.resolve();
    var item = { id: +id, quantity: n || 1 };
    if (props) item.properties = props;
    return api("cart/add.js", { items: [item] })
      .then(refresh)
      .then(function () { if (!silent) open(); pop(); })
      .catch(function (e) { error(e && (e.description || e.message)); });
  }
  function change(line, qty) {
    return api("cart/change.js", { line: line, quantity: qty })
      .then(function (c) { cart = c; render(); })
      .catch(function (e) { error(e && (e.description || e.message)); });
  }

  /* "You may also like" (client feedback, Oct 13: match what is in the bag).
     First, in-stock styles from the same theme collections as the cart's
     products (THEMES, the product page's style groups), ranked by Rebuy's
     picks for this cart, then its top sellers; socks before hats and totes.
     Then Rebuy's own picks (alm-rebuy.js: Rebuy recommendations for the cart,
     top sellers when it's empty), then the theme's best sellers. Never a
     product in the cart, the product page's own product, sold out styles or
     gift cards. Collection data comes from the Shop All JSON view
     (templates/collection.alm-data.liquid), loaded once the drawer opens and
     kept for the session. The drawer redraws when the picks arrive. */
  var THEMES = ["best-furry-friends", "happy-hour", "eat-your-fruits-and-veggies", "weenies-tinis", "the-milestones-collection", "la-dolce-vita", "patterned-collection", "daily-grind-grip-socks", "cloudsoft-bamboo-non-grip", "limited-edition", "hats", "totes"];
  var ACC = ["hats", "totes", "accessories"];
  var REBUY = [], THEME = [], ACCS = [], rebuySig = null, wanted = false;
  var shopData = null;
  function catalog() {
    if (shopData) return shopData;
    var KEY = "almcat:" + ((window.Shopify && Shopify.currency && Shopify.currency.active) || "");
    try {
      var s = JSON.parse(sessionStorage.getItem(KEY) || "null");
      if (s && Date.now() - s.t < 10 * 60 * 1000) return (shopData = Promise.resolve(s.v));
    } catch (e) {}
    return (shopData = fetch(ROOT + "collections/shop-all?view=alm-data").then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (d) {
      var v = (d.products || []).map(function (p) {
        var m = /\/products\/([^/?#]+)/.exec(p.u || "");
        return { h: m ? m[1] : "", v: p.v, t: p.t, p: Math.round((p.p || 0) * 100), i: p.i ? (p.i.indexOf("//") === 0 ? "https:" + p.i : p.i) : "", s: p.s, gc: p.gc, c: p.h || [], ct: p.ct || [] };
      }).filter(function (p) { return p.h; });
      try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), v: v })); } catch (e) {}
      return v;
    }).catch(function () { shopData = null; return []; }));
  }
  function rebuyPicks() {
    if (!wanted) return;
    var ids = cart.items.map(function (l) { return l.product_id; });
    var sig = ids.join(",");
    if (sig === rebuySig) return;
    rebuySig = sig;
    var here = window.ALM_PDP && ALM_PDP.handle;
    var cartH = cart.items.map(function (l) { return l.handle; }).concat(here ? [here] : []);
    var none = function () { return []; };
    var RB = window.AlmRebuy;
    var rec = RB ? (ids.length ? RB.handles("products/recommended", { shopify_product_ids: sig, limit: 16 }) : RB.handles("products/top_sellers", { limit: 16 })).catch(none) : Promise.resolve([]);
    var top = RB ? RB.handles("products/top_sellers", { limit: 60 }).catch(none) : Promise.resolve([]);
    var picks = RB
      ? (ids.length
        ? RB.cards("products/recommended", { shopify_product_ids: sig, limit: 16 }, { limit: 8, exclude: cartH })
        : RB.cards("products/top_sellers", { limit: 16 }, { limit: 8, exclude: cartH })).catch(none)
      : Promise.resolve([]);
    Promise.all([ids.length ? catalog() : Promise.resolve([]), rec, top, picks]).then(function (r) {
      if (sig !== rebuySig) return;
      var all = r[0], pos = {};
      r[1].forEach(function (h, i) { if (!(h in pos)) pos[h] = i; });
      r[2].forEach(function (h, i) { if (!(h in pos)) pos[h] = 100 + i; });
      var byH = {};
      all.forEach(function (p) { byH[p.h] = p; });
      var themes = {};
      cart.items.forEach(function (l) {
        ((byH[l.handle] || {}).c || []).forEach(function (c) { if (THEMES.indexOf(c) > -1) themes[c] = 1; });
      });
      var acc = function (p) { return p.c.some(function (c) { return ACC.indexOf(c) > -1; }); };
      var mates = all.map(function (p, i) { return { p: p, i: i }; }).filter(function (x) {
        var p = x.p;
        return !p.s && !p.gc && p.v && cartH.indexOf(p.h) < 0 && p.c.some(function (c) { return themes[c]; });
      }).sort(function (a, b) {
        var ka = acc(a.p) ? 1 : 0, kb = acc(b.p) ? 1 : 0;
        if (ka !== kb) return ka - kb;
        var ra = a.p.h in pos ? pos[a.p.h] : 1000 + a.i, rb = b.p.h in pos ? pos[b.p.h] : 1000 + b.i;
        return ra - rb;
      }).map(function (x) {
        var p = x.p, g = "";
        THEMES.some(function (c) { var k = p.c.indexOf(c); if (k > -1) { g = p.ct[k] || ""; return true; } return false; });
        return { h: p.h, v: p.v, t: p.t, p: p.p, i: p.i, g: g, k: g, ns: acc(p) };
      });
      mates.forEach(function (m) { if (!CAT[m.h]) register([m]); });
      register(r[3]);
      // Accessories for the row's guaranteed accessory spot (client, Oct 13:
      // a different price point for AOV): in stock, Rebuy's ranking, single
      // hats and totes before hat + sock sets.
      var accs = all.map(function (p, i) { return { p: p, i: i }; }).filter(function (x) {
        var p = x.p;
        return !p.s && !p.gc && p.v && cartH.indexOf(p.h) < 0 && acc(p);
      }).sort(function (a, b) {
        var sa = a.p.c.indexOf("bundles") > -1 ? 1 : 0, sb = b.p.c.indexOf("bundles") > -1 ? 1 : 0;
        if (sa !== sb) return sa - sb;
        var ra = a.p.h in pos ? pos[a.p.h] : 1000 + a.i, rb = b.p.h in pos ? pos[b.p.h] : 1000 + b.i;
        return ra - rb;
      }).map(function (x) {
        var p = x.p, g = "";
        ACC.some(function (c) { var k = p.c.indexOf(c); if (k > -1) { g = p.ct[k] || ""; return true; } return false; });
        return { h: p.h, v: p.v, t: p.t, p: p.p, i: p.i, g: g, k: g, ns: true };
      });
      accs.forEach(function (m) { if (!CAT[m.h]) register([m]); else CAT[m.h].ns = true; });
      ACCS = accs.map(function (m) { return m.h; });
      THEME = mates.map(function (m) { return m.h; });
      REBUY = r[3].map(function (p) { return p.h; });
      render();
    }, function () {});
  }

  function upsells() {
    var here = window.ALM_PDP && ALM_PDP.handle;
    var ok = function (p) { return p && p.v && !p.s && !inCart(p.h) && p.h !== here && !/gift-card/.test(p.h); };
    var groups = cart.items.map(function (l) { return CAT[l.handle] && CAT[l.handle].g; });
    var pool = ORDER.map(function (h) { return CAT[h]; }).filter(ok);
    var best = pool.filter(function (p) { return p.b; });
    if (best.length < 2) best = pool;
    var picks = [], used = {}, MAX = 8;
    ORDER.forEach(function (h) { delete CAT[h].rb; });
    // Theme mates' socks, then Rebuy's socks, then theme hats and totes, then
    // Rebuy's other picks; the theme's own picks fill any gaps.
    var take = function (list, rb, wantAcc) {
      list.forEach(function (h) {
        var p = CAT[h];
        if (!ok(p) || picks.length >= MAX || picks.indexOf(p) > -1) return;
        if (wantAcc !== undefined && !!p.ns !== wantAcc) return;
        picks.push(p); if (rb) p.rb = 1; if (p.g) used[p.g] = 1;
      });
    };
    take(THEME, false, false);
    take(REBUY, true, false);
    take(THEME, false, true);
    take(REBUY, true);
    // Then a pair from a group already in the bag, one from each other group,
    // the rest of the best sellers, then anything in stock. The row swipes on
    // a phone, so it can offer more than two (client feedback, Oct 9).
    best.forEach(function (p) { if (picks.length < 1 && p.g && groups.indexOf(p.g) > -1) { picks.push(p); used[p.g] = 1; } });
    best.forEach(function (p) { if (picks.length < MAX && !used[p.g] && picks.indexOf(p) < 0) { picks.push(p); used[p.g] = 1; } });
    best.forEach(function (p) { if (picks.length < MAX && picks.indexOf(p) < 0) picks.push(p); });
    pool.forEach(function (p) { if (picks.length < MAX && picks.indexOf(p) < 0) picks.push(p); });
    // Always one accessory, second in the row, unless one is already there.
    var isAcc = function (p) { return !!p.ns || ACCS.indexOf(p.h) > -1; };
    if (picks.length && !picks.some(isAcc)) {
      var a = null;
      ACCS.some(function (h) { var p = CAT[h]; if (ok(p)) { a = p; return true; } return false; });
      if (a) { picks.splice(Math.min(1, picks.length), 0, a); picks = picks.slice(0, MAX); }
    }
    return picks.map(function (p) {
      var vars = [p].concat(pool.filter(function (o) { return o !== p && o.g && o.g === p.g; }).slice(0, 3));
      return { p: p, vars: vars };
    });
  }
  function upHtml(u) {
    var p = u.p;
    // Photo and name open the product page (client, Oct 13: see it before adding).
    var url = ROOT + "products/" + encodeURIComponent(p.h);
    return '<div class="acd-du" data-acd-du><a class="acd-dul" href="' + url + '" data-acd-dul tabindex="-1" aria-hidden="true"><img src="' + esc(p.i) + '" alt=""></a>' +
      '<div class="acd-dub"><span class="acd-kind">' + esc(p.k || p.g || "Grip sock") + '</span><a class="acd-name" href="' + url + '" data-acd-dul>' + esc(p.t) + '</a><span class="acd-price">' + money(p.p) + "</span>" +
      (u.vars.length > 1 ? '<div class="acd-dots">' + u.vars.map(function (o, i) {
        return '<button type="button" class="acd-dv' + (i ? "" : " is-on") + '" data-acd-dv="' + esc(o.h) + '" aria-pressed="' + !i + '" aria-label="' + esc(o.t) + '"><img src="' + esc(o.i) + '" alt=""></button>';
      }).join("") + "</div>" : "") +
      '</div><button class="acd-add" type="button" data-acd-add="' + esc(p.h) + '"' + (p.rb ? " data-acd-rb" : "") + ' aria-label="Add ' + esc(p.t) + ' to cart">Add</button></div>';
  }

  /* Bundle nudge (client, Oct 16: push bundles from the bag, an AOV play).
     Rebuy's bundle discount only covers lines the bundle builder added: they
     carry _widget_id and a shared _r_added_bundle_session_id (alm-bundle.js),
     and the tier counts the pairs in that one session. So a bag with a bundle
     says how many more pairs reach the next tier and offers pairs from the
     Build a Bundle page that join the same session; a bag without a bundle
     links to Build a Bundle. Tiers are display only (header setting) and
     mirror Rebuy's. The page is fetched once, when a bag has a bundle. */
  var BN_URL = root.getAttribute("data-bundle-url") || "";
  var BN_TIERS = (root.getAttribute("data-bundle-tiers") || "").split(",").map(function (t) {
    var x = t.split(":"); return { n: +x[0], pct: +x[1] };
  }).filter(function (t) { return t.n > 0 && t.pct > 0; }).sort(function (a, b) { return a.n - b.n; });
  var BN_PROPS = ["_bundle", "_r_bbsi", "_r_added_bundle_session_id", "_source", "_widget_id", "_attribution"];
  var bnPool = null, bnLoading = false;
  function bnCards() {
    if (bnPool || bnLoading || !BN_URL) return;
    bnLoading = true;
    fetch(BN_URL).then(function (r) { if (!r.ok) throw r; return r.text(); }).then(function (h) {
      var d = new DOMParser().parseFromString(h, "text/html");
      bnPool = [].map.call(d.querySelectorAll("[data-bb-card]"), function (c) {
        return { h: c.getAttribute("data-h"), v: c.getAttribute("data-v"), t: c.getAttribute("data-t"), i: c.getAttribute("data-i"), p: +c.getAttribute("data-p") };
      }).filter(function (x) { return x.h && x.v; });
      render();
    }).catch(function () { bnLoading = false; });
  }
  function bnHtml() {
    if (!BN_URL || !BN_TIERS.length || !cart.items.length) return "";
    var best = null, by = {};
    cart.items.forEach(function (l) {
      var p = l.properties || {}, sid = p._r_added_bundle_session_id;
      if (!sid || !p._widget_id) return;
      var b = by[sid] || (by[sid] = { n: 0, h: [], props: {} });
      b.n += l.quantity; b.h.push(l.handle);
      BN_PROPS.forEach(function (k) { if (p[k] != null && b.props[k] == null) b.props[k] = p[k]; });
      if (!best || b.n > best.n) best = b;
    });
    var top = BN_TIERS[BN_TIERS.length - 1];
    if (!best) {
      return '<p class="acd-bn-msg"><a href="' + esc(BN_URL) + '">Build a bundle</a> of ' + BN_TIERS[0].n + "+ pairs and save up to <b>" + top.pct + "%</b>.</p>";
    }
    var next = BN_TIERS.filter(function (t) { return t.n > best.n; })[0];
    if (!next) return '<p class="acd-bn-msg">Your bundle has our best saving: <b>' + top.pct + "% off</b>.</p>";
    var need = next.n - best.n;
    var msg = '<p class="acd-bn-msg">Add <b>' + need + " more pair" + (need > 1 ? "s" : "") + "</b> to your bundle for <b>" + next.pct + "% off</b>.</p>";
    bnCards();
    var picks = (bnPool || []).filter(function (x) { return best.h.indexOf(x.h) < 0; }).slice(0, 8);
    if (!picks.length) return msg;
    bnAdd = best.props;
    return msg + '<div class="acd-ups-rail">' + picks.map(function (x) {
      var url = ROOT + "products/" + encodeURIComponent(x.h);
      return '<div class="acd-du"><a class="acd-dul" href="' + url + '" tabindex="-1" aria-hidden="true"><img src="' + esc(x.i) + '" alt=""></a>' +
        '<div class="acd-dub"><a class="acd-name" href="' + url + '">' + esc(x.t) + '</a><span class="acd-price">' + money(x.p) + "</span></div>" +
        '<button class="acd-add" type="button" data-acd-bnadd="' + esc(x.v) + '" aria-label="Add ' + esc(x.t) + ' to your bundle">Add</button></div>';
    }).join("") + "</div>";
  }
  var bnAdd = null;

  var TAG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9z"/><circle cx="7.5" cy="7.5" r="1.3"/></svg>';
  var BIN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';
  function render() {
    var box = $("[data-acd-items]");
    var total = cart.total_price || 0, count = cart.item_count || 0;
    box.innerHTML = cart.items.length ? "" : '<p class="acd-empty">Your cart is empty. Start with a pair you love.</p>';
    cart.items.forEach(function (l, i) {
      var line = i + 1;
      // One-size socks don't need "One size" under the name (Rhea, Oct 12); real options still show.
      var sub = l.variant_title && !/^(default title|one ?size|os)$/i.test(l.variant_title.trim()) ? l.variant_title : "";
      // Line discounts (e.g. the Rebuy bundle tiers): show the saving and the original price.
      var off = (l.discounts || []).map(function (x) { return x.title; }).filter(Boolean).join(", ");
      var was = l.original_line_price > l.final_line_price ? "<s>" + money(l.original_line_price) + "</s> " : "";
      var d = document.createElement("div");
      d.className = "acd-li";
      var img = l.image ? l.image + (l.image.indexOf("?") > -1 ? "&" : "?") + "width=240" : "";
      d.innerHTML = '<a class="acd-img" href="' + esc(l.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(img) + '" alt="" loading="lazy"></a>' +
        '<div class="acd-lb"><div class="acd-top"><a class="acd-t" href="' + esc(l.url) + '">' + esc(l.product_title) + '</a><span class="acd-pr">' + was + money(l.final_line_price) + "</span></div>" +
        (sub ? '<div class="acd-sub">' + esc(sub) + "</div>" : "") +
        (off ? '<div class="acd-off">' + TAG + esc(off) + "</div>" : "") +
        '<div class="acd-row"><div class="acd-qty"><button type="button" data-lq="-1" aria-label="Decrease quantity">&minus;</button><output>' + l.quantity + '</output><button type="button" data-lq="1" aria-label="Increase quantity">+</button></div>' +
        '<button class="acd-rm" type="button" aria-label="Remove ' + esc(l.product_title) + '">' + BIN + "</button></div></div>";
      d.querySelectorAll("[data-lq]").forEach(function (b) {
        b.addEventListener("click", function () { change(line, Math.max(0, l.quantity + +b.getAttribute("data-lq"))); });
      });
      d.querySelector(".acd-rm").addEventListener("click", function () { change(line, 0); });
      box.appendChild(d);
    });

    var bn = $("[data-acd-bn]");
    if (bn) { var bh = bnHtml(); bn.innerHTML = bh; bn.hidden = !bh; }
    rebuyPicks();
    var ups = upsells();
    $("[data-acd-ups]").innerHTML = ups.length ? '<b>You may also like</b><div class="acd-ups-rail">' + ups.map(upHtml).join("") + "</div>" : "";
    $("[data-acd-sub]").textContent = money(total);
    $("[data-acd-count]").textContent = count;
    document.querySelectorAll(".alm-count").forEach(function (c) { c.textContent = count; });

    var top = GIFT || SHIP;
    var fill = $("[data-acd-fill]");
    var pct = top ? Math.min(100, total / top * 100) : 100;
    if (fill) fill.style.width = pct + "%";
    // The grip sock pointer rides the end of the fill.
    var th = $("[data-acd-thumb]"); if (th) th.style.left = pct + "%";
    var s = $("[data-acd-ship]"); if (s) s.classList.toggle("is-hit", SHIP > 0 && total >= SHIP);
    var g = $("[data-acd-gift]"); if (g) g.classList.toggle("is-hit", GIFT > 0 && total >= GIFT);

    var msg = "";
    if (GIFT && total >= GIFT) msg = "You unlocked <b>free shipping</b> and a <b>free " + esc(GIFT_NAME) + "</b>. It will be added at checkout.";
    else if (GIFT && total >= SHIP) msg = "Free shipping unlocked. You are <b>" + money(GIFT - total) + "</b> away from a <b>free " + esc(GIFT_NAME) + "</b>.";
    else if (SHIP && total >= SHIP) msg = "You unlocked <b>free shipping</b>.";
    else if (SHIP) msg = "You are <b>" + money(SHIP - total) + "</b> away from <b>free shipping</b>.";
    var m = $("[data-acd-msg]"); if (m) m.innerHTML = msg;
    // Liquid prints the thresholds in the shop's currency; show the converted amount.
    root.querySelectorAll("[data-acd-amt]").forEach(function (el) {
      el.textContent = money(el.getAttribute("data-acd-amt") === "gift" ? GIFT : SHIP);
    });
  }

  var lastFocus = null;
  function open() {
    if (!wanted) { wanted = true; rebuyPicks(); }
    lastFocus = document.activeElement;
    document.documentElement.classList.add("acd-open");
    $("#almCdPanel").setAttribute("aria-hidden", "false");
    var x = $(".acd-x"); if (x) x.focus({ preventScroll: true });
  }
  function close() {
    document.documentElement.classList.remove("acd-open");
    $("#almCdPanel").setAttribute("aria-hidden", "true");
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  root.addEventListener("click", function (e) {
    if (e.target.closest("[data-acd-close]")) { close(); return; }
    var dv = e.target.closest("[data-acd-dv]");
    if (dv) {
      var du = dv.closest("[data-acd-du]"), p = CAT[dv.getAttribute("data-acd-dv")];
      if (!p) return;
      du.querySelectorAll(".acd-dv").forEach(function (x) { x.classList.toggle("is-on", x === dv); x.setAttribute("aria-pressed", x === dv); });
      du.querySelector(".acd-dul img").src = p.i;
      du.querySelector(".acd-name").textContent = p.t;
      du.querySelectorAll("[data-acd-dul]").forEach(function (l) { l.href = ROOT + "products/" + encodeURIComponent(p.h); });
      du.querySelector(".acd-price").textContent = money(p.p);
      du.querySelector("[data-acd-add]").setAttribute("data-acd-add", p.h);
      return;
    }
    var ba = e.target.closest("[data-acd-bnadd]");
    if (ba && bnAdd) { ba.disabled = true; add(ba.getAttribute("data-acd-bnadd"), 1, true, bnAdd); return; }
    var a = e.target.closest("[data-acd-add]");
    if (a) add(a.getAttribute("data-acd-add"), 1, false, a.hasAttribute("data-acd-rb") && window.AlmRebuy ? AlmRebuy.props("Cart You May Also Like") : null);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && document.documentElement.classList.contains("acd-open")) close();
  });
  // The bag icon in the header opens the drawer on every page.
  document.addEventListener("click", function (e) {
    if (e.target.closest(".alm-chrome .alm-cart")) { e.preventDefault(); refresh(); open(); }
  });
  // Any product form on an alm page adds through the drawer instead of
  // navigating to /cart.
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[action$="/cart/add"]') || f.hasAttribute("data-no-drawer")) return;
    e.preventDefault();
    var fd = new FormData(f);
    var id = fd.get("id");
    if (!id) return;
    var btn = f.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    add(id, +(fd.get("quantity") || 1)).then(function () { if (btn) btn.disabled = false; });
  });

  refresh();
  // Picks load a few seconds after the page, or as soon as the drawer opens.
  setTimeout(function () { if (!wanted) { wanted = true; rebuyPicks(); } }, 3000);
  return {
    register: register, add: add, open: open, close: close, refresh: refresh,
    has: function (h) { return !!CAT[h]; }
  };
})();
